import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  useEditor,
  EditorContent,
  NodeViewContent,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from "@tiptap/react";
import { createBlockMarkdownSpec, Node } from "@tiptap/core";
// import Document from "@tiptap/extension-document";
// import Paragraph from "@tiptap/extension-paragraph";
import StarterKit from "@tiptap/starter-kit";
// import TextStyle from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";

import { Table } from "@tiptap/extension-table";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableRow } from "@tiptap/extension-table-row";
import Placeholder from "@tiptap/extension-placeholder";
import { TextAlign } from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import Link from "@tiptap/extension-link";
import { FontSize } from "@tiptap/extension-text-style";
import Gapcursor from "@tiptap/extension-gapcursor";
import Underline from "@tiptap/extension-underline";
// import Blockquote from "@tiptap/extension-blockquote";
// import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Image from "@tiptap/extension-image";
import { FontFamily } from "@tiptap/extension-font-family";
import { Markdown } from "@tiptap/markdown";
import { TaskItem, TaskList } from "@tiptap/extension-list";
import "./style/tiptap.css";

// import "./styles/index.css";
import {
  Button,
  Col,
  Dropdown,
  Row,
  Typography,
  Menu,
  Modal,
  Input,
  ColorPicker,
} from "antd";

import {
  FontSizeOutlined,
  PicLeftOutlined,
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  BoldOutlined,
  ItalicOutlined,
  LineOutlined,
  LinkOutlined,
  MergeCellsOutlined,
  SplitCellsOutlined,
  TableOutlined,
  UnderlineOutlined,
  HighlightOutlined,
  DownOutlined,
} from "@ant-design/icons";
import WebFont from "webfontloader";

WebFont.load({
  google: {
    families: [
      "Roboto",
      "Chakra Petch",
      "Sarabun",
      "Itim",
      "Pridi",
      "Bai Jamjuree",
    ],
  },
});

const EditorContentPage = (props) => {
  const editorRef = useRef(null);
  const [first, setFirst] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false); // สถานะการเปิดปิด Modal
  const [inputValue, setInputValue] = useState("");
  const [content, setContent] = useState(props.value);

  const [linkUrl, setLinkUrl] = useState("");
  const [isLinkModalVisible, setIsLinkModalVisible] = useState(false);
  const [highlightColor, setHighlightColor] = useState(""); // เก็บค่าสีที่เลือก
  const [isModalhighOpen, setIsModalhighOpen] = useState(false);
  const [isModalColorTableOpen, setIsModalColorTableOpen] = useState(false);
  const [ColorTable, setColorTable] = useState("");
  const [markdownInput, setMarkdownInput] = useState("");

  const [isMarkdown, setIsMarkdown] = useState(false);

  // editor tool ที่ใช้
  const editor = useEditor({
    // content: props.value,
    // contentType: "markdown",
    extensions: [
      StarterKit.configure({
        Document,
        // Paragraph,
        Text,
        heading: {
          levels: [1, 2, 3, 4, 5],
        },
        bulletList: {
          keepMarks: true,
          keepAttributes: false,
        },
        orderedList: {
          keepMarks: true,
          keepAttributes: false,
        },
      }).extend({
        // เพิ่มการตั้งค่าคีย์ลัดตรงนี้
        addKeyboardShortcuts() {
          return {
            "Mod-Shift-l": () => {
              this.editor.commands.setTextAlign("left");
              return true;
            },
            "Mod-Shift-e": () => {
              this.editor.commands.setTextAlign("center");
              return true;
            },
            "Mod-Shift-r": () => {
              this.editor.commands.setTextAlign("right");
              return true;
            },
            "Mod-Shift-j": () => {
              this.editor.commands.setTextAlign("justify");
              return true;
            },
            Tab: () => {
              this.editor.commands.insertContent("    ");

              return true;
            },
          };
        },
      }),
      Markdown,
      // Markdown.configure({
      //   // html: true, // อนุญาต html บางส่วน
      //   // tightLists: false, // ให้ list มีระยะห่าง
      //   bulletListMarker: "-",
      // }),
      TaskItem.configure({
        nested: true,
      }),
      TaskList,
      Placeholder.configure({
        placeholder: "You can start writing here.",
      }),
      Image,
      TextAlign.configure({
        types: ["heading", "paragraph", "image"],
      }),
      TextStyle,
      Color.configure({
        types: [TextStyle.name, Table.name, TableCell.name, TableHeader.name],
      }),
      Link.configure({
        openOnClick: false,
        autolink: true,
        validate: (href) => /^https?:\/\//.test(href),
      }),
      FontSize,
      Table.configure({
        resizable: true,
        HTMLAttributes: {
          class: "my-custom-class",
        },
      }),
      TableRow,
      TableHeader,
      TableCell,
      // Document,
      // Paragraph,
      Gapcursor,
      Color.configure({ types: [TableCell.name] }),
      Underline,
      Highlight.configure({ multicolor: true }),
      // Blockquote,
      // HorizontalRule,
      FontFamily.configure({
        fontFamilies: [
          "Roboto",
          "Chakra Petch",
          "Sarabun",
          "Itim",
          "Pridi",
          "Bai Jamjuree",
        ],
      }),
      // CustomReactNode,
    ],
    onUpdate({ editor }) {
      const htmlContent = editor.getHTML();
      // setContent(htmlContent); // อัปเดต state `content`
      setContent(editor.getText()); // อัปเดต state `content`
      //   // onEditorChange(htmlContent); // ส่งเนื้อหาไปยัง callback
      // props.onChange?.(editor.getText());
      props.onChange?.(editor.getHTML());
      // props.onChange?.(editor.getHTML());
      // props.onChange?.({ html: editor.getHTML(), text: editor.getText() });
    },
  });
  // ==========
  const parseMarkdown = () => {
    if (!editor || !editor.markdown) {
      return;
    }

    try {
      setIsMarkdown(false);
      editor.commands.setContent(content, {
        contentType: "markdown",
      });
      // editor.commands.setContent(props.value, {
      //   contentType: "markdown",
      // });
      // editor.commands.setContent(editor.getMarkdown(), {
      //   contentType: "markdown",
      // });
    } catch (err) {
      console.error(err);
    }
  };

  const getEditorAsMarkdown = () => {
    if (!editor) {
      return "";
    }

    try {
      return editor.getMarkdown();
    } catch {
      return editor.getText();
    }
  };
  //===============================
  const fontSizeMenu = [
    { key: "16px", label: "16px" },
    { key: "18px", label: "18px" },
    { key: "24px", label: "24px" },
    { key: "32px", label: "32px" },
    { key: "48px", label: "48px" },
    { key: "60px", label: "60px" },
  ];

  const menu = {
    items: fontSizeMenu,
    onClick: (e) => handleFontSizeChange(e.key), // กำหนด action เมื่อเลือกฟอนต์
  };

  const handleFontSizeChange = (size) => {
    editor.chain().focus().setFontSize(size).run(); // เปลี่ยนขนาดฟอนต์
  };

  const tableMenuItems = [
    {
      key: "insertTable",
      label: "Insert Table",
      onClick: () =>
        editor
          .chain()
          .focus()
          .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
          .run(),
    },
    {
      key: "addColumnBefore",
      label: "Add Column Before",
      onClick: () => editor.chain().focus().addColumnBefore().run(),
      disabled: !editor.can().addColumnBefore(),
    },
    {
      key: "addColumnAfter",
      label: "Add Column After",
      onClick: () => editor.chain().focus().addColumnAfter().run(),
      disabled: !editor.can().addColumnAfter(),
    },
    {
      key: "deleteColumn",
      label: "Delete Column",
      onClick: () => editor.chain().focus().deleteColumn().run(),
      disabled: !editor.can().deleteColumn(),
    },
    {
      key: "addRowBefore",
      label: "Add Row Before",
      onClick: () => editor.chain().focus().addRowBefore().run(),
      disabled: !editor.can().addRowBefore(),
    },
    {
      key: "addRowAfter",
      label: "Add Row After",
      onClick: () => editor.chain().focus().addRowAfter().run(),
      disabled: !editor.can().addRowAfter(),
    },
    {
      key: "deleteRow",
      label: "Delete Row",
      onClick: () => editor.chain().focus().deleteRow().run(),
      disabled: !editor.can().deleteRow(),
    },
    {
      key: "mergeCells",
      label: "Merge Cells",
      icon: <MergeCellsOutlined />,
      onClick: () => editor.chain().focus().mergeCells().run(),
      disabled: !editor.can().mergeCells(),
    },
    {
      key: "splitCells",
      label: "Split Cells",
      icon: <SplitCellsOutlined />,
      onClick: () => editor.chain().focus().splitCell().run(),
      disabled: !editor.can().splitCell(),
    },
    {
      key: "deleteTable",
      label: "Delete Table",
      onClick: () => editor.chain().focus().deleteTable().run(),
      disabled: !editor.can().deleteTable(),
    },
  ];

  const tableMenu = {
    items: tableMenuItems.map((item) => ({
      key: item.key,
      label: (
        <div
          className={item.disabled ? "menu-item-disabled" : ""}
          style={{ pointerEvents: item.disabled ? "none" : "auto" }}
        >
          {item.icon && <span style={{ marginRight: 8 }}>{item.icon}</span>}
          {item.label}
        </div>
      ),
      onClick: item.onClick,
      disabled: item.disabled,
    })),
  };

  const setLink = useCallback(() => {
    if (!editor) return;
    const previousUrl = editor.getAttributes("link").href || "";
    setInputValue(previousUrl);
    setIsModalOpen(true);
  }, [editor]);

  const closeModal = () => {
    setIsModalhighOpen(false);
  };

  // เปลี่ยนสี Highlight แบบเลือกสีเอง ไม่ได้ใช้งาน
  const handleHighlight = useCallback(() => {
    if (!editor) return;
    if (highlightColor) {
      editor
        .chain()
        .focus()
        .setMark("highlight", { color: highlightColor })
        .run();
    } else {
      editor.chain().focus().unsetMark("highlight").run();
    }
    closeModal();
  }, [editor, highlightColor]);

  const handleTableColorChange = useCallback(() => {
    if (!editor) return;

    // เปลี่ยนสี background ของเซลล์โดยใช้ setCellAttribute โดยตรง
    if (ColorTable) {
      editor.chain().focus().setCellAttribute("background", ColorTable).run();
    }
    setIsModalColorTableOpen(false); // ปิด Modal หลังจากเลือกสี
  }, [editor, ColorTable]);

  const handleOk = useCallback(() => {
    if (!editor) return;
    if (inputValue.trim() === "") {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
    } else {
      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: inputValue })
        .run();
    }
    setIsModalOpen(false);
  }, [editor, inputValue]);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
    setIsLinkModalVisible(false);
    setLinkUrl("");
  }, []);

  const formatToCleanMarkdown = (html) => {
    if (!html) return "";
    return html
      .replace(/<p><\/p>/g, "") // ลบย่อหน้าว่าง
      .replace(/<li><p>/g, "<li>") // ลบ p ที่ซ้อนใน li
      .replace(/<\/p><\/li>/g, "</li>") // ลบ p ที่ซ้อนใน li
      .replace(/<li>/g, "- ") // เปลี่ยน li เป็น -
      .replace(/<\/li>/g, "\n") // จบ li ให้ขึ้นบรรทัดใหม่
      .replace(/<[^>]*>/g, "") // ลบ Tag ที่เหลือ (ul, p)
      .replace(/&nbsp;/g, " ") // เปลี่ยน &nbsp; เป็นช่องว่าง
      .replace(/&amp;/g, "&") // แก้ double encode ของ &
      .trim();
  };

  // useEffect(() => {
  //   setContent(props.value);
  // }, [props.value]);

  // useEffect(() => {
  //   if (editor && content !== editor.getHTML()) {
  //     editor.commands.setContent(content);
  //   }
  // }, [content, editor]);

  useEffect(() => {
    if (editor && props.value && first) {
      editor.commands.setContent(props.value);
      setFirst(false);
    }
  }, [editor, props.value, first]);

  if (!editor) {
    return null;
  }

  return (
    <div>
      <div className="editor-toolbar">
        <Row className="bubble-menu" align={"middle"} justify={"space-between"}>
          <Col>
            <div
              // className="bubble-menu"
              style={{
                // border: "1px solid #ddd",
                padding: "3px",
                borderRadius: "8px 8px 0px 0px",
              }}
            >
              <Button
                icon={<BoldOutlined />}
                onClick={() => editor.chain().focus().toggleBold().run()}
                disabled={!editor.can().chain().focus().toggleBold().run()}
                className={editor.isActive("bold") ? "is-active" : ""}
              />
              <Button
                icon={<ItalicOutlined />}
                onClick={() => editor.chain().focus().toggleItalic().run()}
                disabled={!editor.can().chain().focus().toggleItalic().run()}
                className={editor.isActive("italic") ? "is-active" : ""}
              />
              <Button
                icon={<UnderlineOutlined />}
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                className={editor.isActive("underline") ? "is-active" : ""}
              ></Button>
              <Dropdown menu={menu} trigger={["click"]}>
                <Button icon={<FontSizeOutlined />}>
                  <DownOutlined />
                </Button>
              </Dropdown>

              <Button
                icon={<HighlightOutlined />}
                onClick={() => editor.chain().focus().toggleHighlight().run()}
                className={editor.isActive("highlight") ? "is-active" : ""}
              ></Button>
              <Input
                type="color"
                onInput={(event) =>
                  event.target.value &&
                  editor.chain().focus().setColor(event.target.value).run()
                }
                value={editor.getAttributes("textStyle").color}
                data-testid="setColor"
                style={{ marginRight: "15px", width: "40px" }}
              />

              {/* aglie */}
              <Button
                icon={<AlignLeftOutlined />}
                onClick={() =>
                  editor.chain().focus().setTextAlign("left").run()
                }
                className={
                  editor.isActive({ textAlign: "left" }) ? "is-active" : ""
                }
              />
              <Button
                icon={<AlignCenterOutlined />}
                onClick={() =>
                  editor.chain().focus().setTextAlign("center").run()
                }
                className={
                  editor.isActive({ textAlign: "center" }) ? "is-active" : ""
                }
              />
              <Button
                icon={<AlignRightOutlined />}
                onClick={() =>
                  editor.chain().focus().setTextAlign("right").run()
                }
                className={
                  editor.isActive({ textAlign: "right" }) ? "is-active" : ""
                }
              />
              <Button
                icon={<PicLeftOutlined />}
                onClick={() => editor.chain().focus().toggleBlockquote().run()}
                className={editor.isActive("blockquote") ? "is-active" : ""}
              ></Button>
              <Button
                icon={<LineOutlined />}
                onClick={() => editor.chain().focus().setHorizontalRule().run()}
                style={{ marginRight: "15px" }}
              ></Button>
              <Button
                icon={<LinkOutlined />}
                onClick={setLink}
                disabled={
                  !editor?.can().chain().focus().setLink({ href: "" }).run()
                }
              ></Button>
              <Dropdown menu={tableMenu} trigger={["click"]}>
                <Button icon={<TableOutlined />}>
                  <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          </Col>
          <Col>
            <div
              style={{
                // border: "1px solid #ddd",
                padding: "3px",
                borderRadius: "8px 8px 0px 0px",
              }}
            >
              {isMarkdown ? (
                <Button onClick={parseMarkdown}>Text</Button>
              ) : (
                <Button
                  onClick={() => {
                    setIsMarkdown(true);
                    const markdown = getEditorAsMarkdown();

                    editor.chain().focus().selectAll().deleteSelection().run();

                    props.onChange?.(markdown);
                    editor.commands.insertContent(markdown);
                    // ==============================
                    // setIsMarkdown(true);
                    // const markdown = getEditorAsMarkdown();
                    // editor.chain().focus().selectAll().deleteSelection().run();
                    // editor.commands.insertContent(markdown, {
                    //   contentType: "html",
                    // });
                  }}
                >
                  Markdown
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div
        style={{
          minHeight: "12em",
          padding: "10px",
          // lineHeight: "1.0em",
          backgroundColor: "white",
          border: "1px solid #d9d9d9",
          borderRadius: "4px",
          cursor: "text",
          // maxHeight: "5rem",
          // overflowY: "scroll",
        }}
        className="editor-box"
        onClick={() => {
          if (editor) {
            editor.commands.focus();
          }
        }}
      >
        {isMarkdown ? (
          <Input.TextArea
            // rows={6}
            style={{ border: "none" }}
            autoSize={{ minRows: 6 }}
            value={content}
            // value={props.value}
            // value={formatToCleanMarkdown(props.value)}
            onChange={(e) => {
              setContent(e.target.value);
              // props.onChange?.(e.target.value);
            }}
          />
        ) : (
          <EditorContent editor={editor} ref={editorRef} />
        )}
        {/* <EditorContent editor={editor} ref={editorRef} /> */}
      </div>

      {/* modal */}
      <Modal
        title="Set Link"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Input
          placeholder="Enter URL"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </Modal>

      {/* Modal สำหรับเลือกสีพื้นหลังตาราง */}
      <Modal
        title="Select Table Background Color"
        open={isModalColorTableOpen}
        onOk={handleTableColorChange}
        onCancel={() => setIsModalColorTableOpen(false)}
      >
        <Input
          type="color"
          onInput={(event) =>
            event.target.value &&
            editor.chain().focus().setColor(event.target.value).run()
          }
          value={editor.getAttributes("table").color}
          data-testid="setColor"
          style={{ marginRight: "15px", width: "40px" }}
        />
      </Modal>

      {/* hightlight */}
      <Modal
        title="Select Highlight Color"
        open={isModalhighOpen}
        onOk={handleHighlight}
        onCancel={closeModal}
      >
        <ColorPicker
          value={highlightColor}
          onChange={(color) => setHighlightColor(color.toHexString())}
        />
      </Modal>
    </div>
  );
};

export default EditorContentPage;
